module.exports = __webpack_public_path__ + "static/breizhcamp2019-e6db4c62d05e99780089711b92e6c8e4.png";